const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN

type SentryModule = typeof import('@sentry/react')

let sentryPromise: Promise<SentryModule> | null = null

export function loadSentry() {
  if (!SENTRY_DSN) return null
  sentryPromise ??= import('@sentry/react').then(Sentry => {
    Sentry.init({
      dsn: SENTRY_DSN,
      environment: import.meta.env.MODE,
      tracesSampleRate: 0.1,
      sendDefaultPii: false,
    })
    return Sentry
  })
  return sentryPromise
}

export function scheduleSentryLoad() {
  if (!SENTRY_DSN) return

  const start = () => { void loadSentry() }
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(start, { timeout: 3000 })
  } else {
    setTimeout(start, 0)
  }
}
